import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

// Directives
import { ClickOutsideDirective } from '@bazis/shared/directives/click-outside.directive';
import { IfPropertyDirective } from '@bazis/shared/directives/if-property.directive';
import { IfControlDirective } from '@bazis/shared/directives/if-control.directive';
import { LocalRouterLinkDirective } from '@bazis/shared/directives/local-router-link.directive';

// Pipes
import { EntityPipe } from '@bazis/shared/pipes/entity.pipe';
import { StatusPipe } from '@bazis/shared/pipes/status.pipe';
import { EnumPipe } from '@bazis/shared/pipes/enum.pipe';
import { PluralPipe } from '@bazis/shared/pipes/plural.pipe';
import { LocalDatePipe } from '@bazis/shared/pipes/local-date.pipe';
import { LocalNumberPipe } from '@bazis/shared/pipes/local-number.pipe';

// Modules
import { DatepickerModule } from '@bazis/shared/components/web/datepicker/datepicker.module';
import { TimepickerModule } from '@bazis/shared/components/web/timepicker/timepicker.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ColModule } from '@bazis/shared/components/web/grid/col/col.module';
import { GridModule } from '@bazis/shared/components/web/grid/grid/grid.module';
import { RowModule } from '@bazis/shared/components/web/grid/row/row.module';
import { ToggleModule } from '@bazis/shared/components/web/toggle/toggle.module';
import { TabsModule } from '@bazis/shared/components/web/tabs/tabs.module';
import { ChipModule } from '@bazis/shared/components/web/chip/chip.module';
import { BadgeModule } from '@bazis/shared/components/web/badge/badge.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { LogoModule } from '@bazis/shared/components/web/logo/logo.module';
import { LinkModule } from '@bazis/shared/components/web/link/link.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { ToolbarModule } from '@bazis/shared/components/web/toolbar/toolbar.module';
import { StepModule } from '@bazis/shared/components/web/step/step.module';
import { AccordionModule } from '@bazis/shared/components/web/accordion/accordion.module';
import { TripLineModule } from '@bazis/shared/components/web/trip-line/trip-line.module';
import { SkeletonModule } from '@bazis/shared/components/web/skeleton/skeleton.module';
import { RangeModule } from '@bazis/shared/components/web/range/range.module';
import { ThumbnailModule } from '@bazis/shared/components/web/thumbnail/thumbnail.module';
import { CardValueModule } from '@bazis/shared/components/web/card-value/card-value.module';
import { SignStatusModule } from '@bazis/shared/components/web/sign-status/sign-status.module';
import { LayoutPressFooterModule } from '@bazis/shared/components/web/layout-press-footer/layout-press-footer.module';
import { InterrogationModule } from '@bazis/shared/components/web/interrogation/interrogation.module';
import { TotopModule } from '@bazis/shared/components/web/totop/totop.module';
import { SegmentModule } from '@bazis/shared/components/web/segment/segment.module';
import { StarModule } from '@bazis/shared/components/web/star-rating/star/star.module';
import { StarsModule } from '@bazis/shared/components/web/star-rating/stars/stars.module';
import { LabelModule } from '@bazis/shared/components/web/label/label.module';
import { AvatarModule } from '@bazis/shared/components/web/avatar/avatar.module';
import { IndicatorModule } from '@bazis/shared/components/web/indicator/indicator.module';
import { TimerModule } from '@bazis/shared/components/web/timer/timer.module';

import { BreadcrumbsComponent } from '@bazis/shared/components/breadcrumbs/breadcrumbs.component';
import { StatusComponent } from '@bazis/shared/components/status/status.component';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { BackgroundDirective } from '@bazis/shared/directives/background.directive';

const CRUTIAL_STANDALONE = [
    EntityPipe,
    StatusPipe,
    EnumPipe,
    PluralPipe,
    LocalDatePipe,
    LocalNumberPipe,

    ClickOutsideDirective,
    IfPropertyDirective,
    IfControlDirective,
    LocalRouterLinkDirective,
    ColorDirective,
    BackgroundDirective,

    BreadcrumbsComponent,
    StatusComponent,
];

const WEB_COMPONENT_MODULES = [
    GridModule,
    RowModule,
    ColModule,
    IconModule,
    ToggleModule,
    TabsModule,
    ChipModule,
    BadgeModule,
    ButtonModule,
    LogoModule,
    LinkModule,
    DatepickerModule,
    TimepickerModule,
    TooltipModule,
    ToolbarModule,
    StepModule,
    AccordionModule,
    TripLineModule,
    SkeletonModule,
    RangeModule,
    ThumbnailModule,
    CardValueModule,
    SignStatusModule,
    LayoutPressFooterModule,
    InterrogationModule,
    TotopModule,
    SegmentModule,
    StarModule,
    StarsModule,
    LabelModule,
    AvatarModule,
    IndicatorModule,
    TimerModule,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        TranslocoModule,
        ...WEB_COMPONENT_MODULES,
        ...CRUTIAL_STANDALONE,
    ],
    exports: [...WEB_COMPONENT_MODULES, ...CRUTIAL_STANDALONE, CommonModule, TranslocoModule],
})
export class BazisCoreSharedModule {}
